import { queryOptions, useQuery } from '@tanstack/react-query';
import type { ResponseType } from 'axios';

import { loadJwPlayer } from '@services/JwPlayerService';
import { loadFromAPIs } from '@utilities/fetch';
import { uefaApiBaseUrl, uefaBaseUrl } from '@utilities/WindowContext';

export const getLibraryContentQuery = <T = unknown>(libraryPath: string, responseType?: ResponseType) =>
  queryOptions({
    queryKey: ['library', libraryPath, responseType],
    queryFn: ({ signal }) => loadFromAPIs<T>(libraryPath, {}, { apiUrl: uefaBaseUrl, responseType, signal }),
    enabled: !!libraryPath,
    select: (response) => (typeof response === 'string' ? response?.trim() : response) as T,
  });

export const getEndpointQuery = <T = unknown>(controllerPath: string) =>
  queryOptions({
    queryKey: ['controller', controllerPath],
    queryFn: ({ signal }) => loadFromAPIs<T>(controllerPath, {}, { apiUrl: uefaApiBaseUrl, signal }),
    enabled: !!controllerPath,
  });

export const useJwPlayer = () =>
  useQuery({
    queryKey: ['jwplayer'],
    queryFn: () => loadJwPlayer(),
  });
